import React, { Component } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { calculatePrice } from "../pricing/calculatePrice";
import Axios from "axios";
import ReactToPrint from "react-to-print";
import { configuration } from "../appConfig";
import { connect } from "react-redux";
import ScrollToTop from "./common/ScrollToTop";
import SwissFrenchPriceTable_v2 from "./common/SwissFrenchPriceTable_v2";
import SwissFrenchPriceTableWithGlue_v2 from "./common/SwissFrenchPriceTableWithGlue_v2";
import CarSvgFrench from "../carbodyparts/CarSvgFrench";
import AllReportScanImages from "./common/AllReportScanImages";
import Newswiss_CustomerInfoTable from "./common/newswiss_CustomerInfoTable";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import Spinner from "../../src/spinner/index";
import SwissFullReportAuthorization2 from "./common/SwissFullReportAuthorization2";


let selectedFile = localStorage.getItem("selectedFile");

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export class ReportFullFrench extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: "",
      order: {
        vinNumber: "",
        orderNumber: Math.round(Math.random() * 100000000),
        issuedOn: new Date(),
      },
      partDetails: null,
      twoDView: true,
      vinNumber: null,
      vinfolderList: [],
      words: {},
      lang: "gb",
      // extraImages: [],
      // extraImages_1:[],
      imageLoading: false,
      jsonData: {},
      isAnyOnecheck: false,
      isShowReplaceColumn: false,
    };
    this.setImageLoading = this.setImageLoading.bind(this);
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  setImageLoading(loading) {
    this.setState({ imageLoading: loading });
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  async componentDidMount() {
    selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    this.getData(selectedFile)
    await this.vinFolderList();
    this.getLang();
    // await this.extraImages();
  }
  countDetails = async (rowArray) => {
    selectedFile = localStorage.getItem("selectedFile")
    let partnerId = localStorage.getItem("partnerId");
    let promises = [];
    for (let i = 0; i < rowArray.length; i++) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      promises.push(Axios.get(url));
    }
    const arrRes = await Axios.all(promises);
    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");
      val.map((r) => {
        let val2 = r.split(" ")[3];
        if (val2 && parseInt(val2) > 25) {
          gtcount = gtcount + 1;
        }
        if (val2 && parseInt(val2) < 26) {
          ltcount = ltcount + 1;
        }
        return val2;
      });
      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
  };
  vinFolderList = async () => {
    let partnerId = localStorage.getItem("partnerId");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId
      );

      // isScanListRecord START
      if (response.data[0]) {
        this.setState({
          isScanListRecord: response.data[0].isScanListRecord,
        });
      }
      // isScanListRecord END

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
      }
    } else {
      this.props.history.push("/login");
    }
  };

  getData = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.setState({
          jsonData: r.data,
        }, () => {
            this.checkStatus()
            this.getFallbackDetails();
          })
      }
    }).catch((err) => alert(err))
  }

  getFallbackDetails = async () => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await Axios.get(url);
      if (res.data) {
        this.setState({
          isShowReplaceColumn: parseInt(res.data.is_show_replace_column) === 1 ? true : false,
        });
      }
    } catch (error) {
      this.setState({
        isShowReplaceColumn: false,
      });
    }
  };

  changeAuthorizeFlag = (authorize) => {
    this.setState({
      jsonData: { ...this.state.jsonData, Authorized: authorize },
    });
  };

  checkStatus = () => {
    const { jsonData } = this.state;
    const isAnyOnecheck = jsonData && jsonData.Dents && jsonData.Dents.some(item => item.AE && item.AE.length > 0 || item.Ersetzen && item.Ersetzen.length > 0);
    this.setState({ isAnyOnecheck });
  }

  render() {
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    const { imageLoading, isShowReplaceColumn } = this.state;
    return (
      <div className="animated fadeIn">
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <small>
                      {" "}
                      <span>{this.lang("VIN Number")} :</span> {selectedFile}
                    </small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      {/* <ReportAuthorizationHandler
                          jsonData={jsonData}
                          lang={this.lang}
                          reportType={"full"}
                          isAuthorized={jsonData.Authorized}
                          changeAuthorizeFlag={(authorize) =>
                            this.changeAuthorizeFlag(authorize)
                          }
                          selectedLanguage={lang}
                        /> */}
                      <SwissFullReportAuthorization2 />
                      <ReactToPrint
                        trigger={() => {
                          document.title = selectedFile;
                          return (
                            <button className="btn btn-danger btn-lg pull-right">
                              <i className="fa fa-print" />{" "}
                              {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <CardBody style={{ padding: 0 }}>
            <div
              className="container all-reports-top-wrapper"
              // id="divIdToPrint"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
            >
              {!imageLoading ? (
                <>
                  <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                    <div className="col-sm-12 full-height-col col-zero">
                      <Card>
                        {/* <ReportHeader /> */}
                        <ReportHeader_Swiss />
                        <CardBody className="col-zero report_swiss_french">
                          <div className="newFormatReport_wrapper">
                            {/* <div className="row w-100"> */}
                            {/* <CustomerInfoTable_newswiss /> */}
                            <Newswiss_CustomerInfoTable />
                            {partnerId == "28-240601" ? (
                              <SwissFrenchPriceTableWithGlue_v2
                                getUpdatedStateFromPriceTable={(data) =>
                                  this.getUpdatedStateFromPriceTable(data)
                                }
                                isUseBasePrice={true}
                              />
                            ) : (
                              <SwissFrenchPriceTable_v2
                                getUpdatedStateFromPriceTable={(data) =>
                                  this.getUpdatedStateFromPriceTable(data)
                                }
                                isUseBasePrice={true}
                              />
                            )}
                            {/* <SwissFrenchPriceTable
                            getUpdatedStateFromPriceTable={(data) =>
                              this.getUpdatedStateFromPriceTable(data)
                            }
                          /> */}
                            {/* </div> */}
                          </div>
                        </CardBody>
                        {/* <ReportFooter reportType="newReportFull" /> */}
                        <ReportFooter_Swiss />
                      </Card>
                    </div>
                  </div>

                  {this.state.isAnyOnecheck && isShowReplaceColumn &&
                    <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                      <div className="col-sm-12 full-height-col col-zero">
                        <Card>
                          <CardBody className="col-zero">
                            <div className="newFormatReport_wrapper">
                              <ReportHeader_Swiss />
                              {partnerId == "28-240601" ? (
                                <SwissFrenchPriceTableWithGlue_v2
                                  getUpdatedStateFromPriceTable={(data) =>
                                    this.getUpdatedStateFromPriceTable(data)
                                  }
                                  isUseBasePrice={false}
                                  is_extra_columns_visible_mini_fullreport={true}
                                />
                              ) : (
                                <SwissFrenchPriceTable_v2
                                  getUpdatedStateFromPriceTable={(data) =>
                                    this.getUpdatedStateFromPriceTable(data)
                                  }
                                  isUseBasePrice={false}
                                  is_extra_columns_visible_mini_fullreport={true}
                                />
                              )}
                              {/* <div className="p-0 row ">
                        </div> */}
                            </div>
                          </CardBody>
                          <ReportFooter_Swiss />
                        </Card>
                      </div>
                    </div>
                  }

                  {this.state.isScanListRecord == "0" && (
                    <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                      <div className="col-sm-12 full-height-col col-zero">
                        <Card>
                          <CardBody className="col-zero">
                            <div className="newFormatReport_wrapper">
                              {/* <ReportHeader /> */}
                              <ReportHeader_Swiss />
                              <div className="container car-svg-main">
                                <div className="row title-row-main">
                                  <div className="col-sm-12 col-zero">
                                    <h3 className="report-title">
                                      {this.lang("2D")}<span> {this.lang("View")}</span>{" "}
                                    </h3>
                                  </div>
                                </div>
                                <div className="row row-zero">
                                  <div className="col-sm-12 text-center">
                                    <CarSvgFrench {...this.props} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </CardBody>
                          {/* <ReportFooter reportType="newReportFull" /> */}
                          <ReportFooter_Swiss />
                        </Card>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <Spinner />
                </>
              )}
              <AllReportScanImages imageLoading={this.state.imageLoading} setImageLoading={this.setImageLoading} />

            </div>
          </CardBody>
          {/* <div>
          {!imageLoading && (
            <>
            <Card>
              <CardBody>
                <Link className="glass" to="/ReportFull">
                  <button className="btn btn-danger btn-sm pull-right">
                    <i className="fa fa-dot-circle-o"></i> {">>"}
                  </button>
                </Link>
                <Link className="glass" to="/TabView">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn btn-danger btn-sm pull-right"
                  >
                    {"<<"} <i className="fa fa-dot-circle-o"></i>
                  </button>
                </Link>
              </CardBody>
            </Card>
            </>
          )
          }
          </div> */}
        </div>
        <div>
          <ScrollToTop />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(ReportFullFrench);